import React from "react"
import "../style.css"
import Appbar from "../components/appbar"
import { graphql } from "gatsby"
import ExpCard from "../components/experience_card"
import SEO from "../components/SEO"

function WorkExperience({ data }) {
  const projectList = data.allWorkYaml.edges
  let idx = 0
  const readMoreLinks = data.allMarkdownRemark.edges
  console.log('readMoreLinks', readMoreLinks)
  return (
    <div className="container-fluid">
      <Appbar />
      <SEO title="Work Experience | Kaustubh" />
      <div className="row">
        {projectList.map(({ node }) => {
          return (
            <ExpCard
              cardTitle={node.company}
              cardSubtitle={node.position}
              cardDuration={node.duration}
              key={node.id}
              cardImage={node.image}
              cardLocation={node.location}
              readMore={readMoreLinks[idx++].node.frontmatter.path}
            />
          )
        })}
      </div>
    </div>
  )
}

export default WorkExperience


export const query = graphql`
  {
    allWorkYaml {
      edges {
        node {
          company
          position
          duration
          id
          image
          location
          readMore
        }
      }
    }
    allMarkdownRemark(sort: {order: DESC, fields: frontmatter___date}) {
      edges {
        node {
          id
          frontmatter {
            path
          }
        }
      }
    }
  }
`
